import { render, staticRenderFns } from "./PageSidenav.vue?vue&type=template&id=bb3a14de&scoped=true&"
import script from "./PageSidenav.vue?vue&type=script&lang=js&"
export * from "./PageSidenav.vue?vue&type=script&lang=js&"
import style0 from "./PageSidenav.vue?vue&type=style&index=0&id=bb3a14de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3a14de",
  null
  
)

export default component.exports